import {
  LayoutDashboard, Flag, DollarSign, Link2, Zap, BarChart3,
  FileText, Search, Users, UserCircle, Settings, HelpCircle,
  Bell, Bot, Menu, X, Moon, Sun, LogOut, Layout, Megaphone, Globe, Package, Send, Radar, RotateCcw, Clock,
  CalendarDays, ShieldCheck, Building2, CreditCard, History, ClipboardList, SunMedium, Star, Lock, Trophy, MessageSquare, ArrowUpRight, Shield, Kanban, Smartphone
} from 'lucide-react';

// ==================== VERSION ====================
export const TOUR_VERSION = '2.0';

// ==================== ALL NAV ITEMS ====================
// Single source of truth: navigation + tour content
const ALL_ITEMS = {
  // ---- ADMIN ----
  dashboard: {
    key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/sistema',
    tourDesc: 'Visao geral com KPIs em tempo real, metricas e atividade recente do sistema.',
    tabTour: { title: 'Dashboard', desc: 'Visao geral da sua operacao. Acompanhe metricas, saude do sistema e atividades recentes em tempo real.', tips: ['KPIs e metricas', 'Saude do sistema', 'Atividades recentes'], version: 2 },
  },
  campanhas: {
    key: 'campanhas', label: 'Campanhas', icon: Flag, path: '/sistema/campanhas',
    tourDesc: 'Crie e gerencie campanhas de divulgacao. Configure metas e acompanhe resultados.',
    tabTour: { title: 'Campanhas', desc: 'Crie e gerencie campanhas de ofertas. Configure periodos, publico-alvo e acompanhe resultados.', tips: ['Criar campanhas', 'Acompanhar performance', 'Gerenciar ofertas ativas'], version: 2 },
  },
  promocoes: {
    key: 'promocoes', label: 'Promoções', icon: Megaphone, path: '/sistema/promocoes',
    tourDesc: 'Central de Promoções: campanhas da vitrine, destaques por loja e ofertas relampago.',
    tabTour: { title: 'Promoções', desc: 'Campanhas promocionais da Home. Defina periodo, prioridade, loja e contador regressivo.', tips: ['Campanhas com data de inicio e fim', 'Prioridade define a ordem na vitrine', 'Contador so aparece com data de fim real'], version: 1 },
  },
  gestao: {
    key: 'gestao', label: 'Gestão', icon: DollarSign, path: '/sistema/gestao',
    tourDesc: 'Painel financeiro e operacional. Resumo, contas, auditoria e controle de gestao.',
    tabTour: { title: 'Gestao', desc: 'Painel central de gestao. Controle financeiro, auditoria e operacoes do dia a dia.', tips: ['Resumo financeiro', 'Contas e auditoria', 'Operacoes diarias'], version: 2 },
  },
  'admin-crm': {
    key: 'admin-crm', label: 'CRM HUB', icon: Kanban, path: '/sistema/admin/crm',
    tourDesc: 'Gestao comercial com pipeline Kanban, timeline, acoes rapidas e notificacoes.',
    tabTour: { title: 'CRM HUB', desc: 'Gestao comercial e relacionamento empresarial. Pipeline Kanban, timeline e acoes rapidas.', tips: ['Pipeline Kanban', 'Dados comerciais', 'Acoes rapidas'], version: 2 },
  },
  pedidos: {
    key: 'pedidos', label: 'Pedidos', icon: Package, path: '/sistema/pedidos',
    tourDesc: 'Gerencie pedidos de oferta, demandas e categorias inteligentes.',
    tabTour: { title: 'Pedidos', desc: 'Acompanhe todos os pedidos em tempo real. Gerencie status, entregas e historico completo.', tips: ['Status em tempo real', 'Historico de pedidos', 'Categorias'], version: 2 },
  },
  comissoes: {
    key: 'comissoes', label: 'Comissões', icon: DollarSign, path: '/sistema/comissoes',
    tourDesc: 'Quanto o Super Vitrine faturou de comissao por loja, categoria e oferta.',
    tabTour: { title: 'Comissoes', desc: 'Comissao real importada dos programas de afiliado.', tips: ['Importar relatorio', 'Comissao por loja', 'EPC e conversao'], version: 1 },
  },
  descobertas: {
    key: 'descobertas', label: 'Descobertas', icon: Radar, path: '/sistema/descobertas',
    tourDesc: 'Ofertas rastreadas automaticamente. Explore tendencias e oportunidades.',
    tabTour: { title: 'Descobertas', desc: 'Explore novas oportunidades. Ofertas rastreadas e tendencias de mercado.', tips: ['Tendencias de mercado', 'Rastreamento automatico', 'Oportunidades'], version: 2 },
  },
  'cowork-ofertas': {
    key: 'cowork-ofertas', label: 'Cowork Ofertas', icon: Search, path: '/sistema/cowork-ofertas',
    tourDesc: 'Candidatos encontrados pelo Cowork, validados em shadow. Nada daqui é publicado.',
    tabTour: { title: 'Cowork Ofertas', desc: 'Fonte complementar em shadow: ingestão, validação e relatório. Sem publicação.', tips: ['Ingestão por lote', 'Mesmos gates do Super Vitrine', 'Aprovar só para shadow'], version: 1 },
  },
  'ml-afiliados': {
    key: 'ml-afiliados', label: 'Afiliados ML', icon: Link2, path: '/sistema/ml-afiliados',
    tourDesc: 'Cobertura de links oficiais do Mercado Livre e lote diário para o Gerador de Links do Portal.',
    tabTour: { title: 'Afiliados ML', desc: 'Workflow manual oficial: lote priorizado, Portal, preview e import só dos válidos.', tips: ['Lote Top 30 por dia', 'Preview antes de gravar', 'F1 publica mesmo sem link'], version: 1 },
  },
  'amazon-manual': {
    key: 'amazon-manual', label: 'Amazon manual', icon: Link2, path: '/sistema/amazon-manual',
    tourDesc: 'Oferta Amazon com o link oficial do SiteStripe, sem preço, até a Creators API liberar.',
    tabTour: { title: 'Amazon manual', desc: 'Cadastre a oferta com o link do SiteStripe. Sem preço, sem busca na Amazon; publicação só com preview.', tips: ['Link https://link.amazon/... intacto', 'Sem preço até a API oficial', 'Publicar Amazon pede preview'], version: 1 },
  },
  conexoes: {
    key: 'conexoes', label: 'Conexões', icon: Link2, path: '/sistema/conexoes',
    tourDesc: 'Configure integracoes com Telegram, WhatsApp e outras plataformas.',
    tabTour: { title: 'Conexoes', desc: 'Gerencie canais de comunicacao. Telegram, WhatsApp e integrações.', tips: ['Canais conectados', 'Novo canal', 'Status de integracoes'], version: 2 },
  },
  automacoes: {
    key: 'automacoes', label: 'Automações', icon: Zap, path: '/sistema/automacoes',
    tourDesc: 'Configure automacoes, regras e agendamentos para otimizar operacoes.',
    tabTour: { title: 'Automacoes', desc: 'Configure automacoes para otimizar sua operacao. Regras, gatilhos e acoes automaticas.', tips: ['Regras automaticas', 'Gatilhos por evento', 'Agendamentos'], version: 2 },
  },
  performance: {
    key: 'performance', label: 'Performance', icon: BarChart3, path: '/sistema/performance',
    tourDesc: 'Analise metricas avancadas, graficos de desempenho e insights de crescimento.',
    tabTour: { title: 'Performance', desc: 'Analise detalhada de performance. Graficos, metricas avancadas e insights de crescimento.', tips: ['Graficos detalhados', 'Metricas avancadas', 'Insights'], version: 2 },
  },
  templates: {
    key: 'templates', label: 'Templates', icon: FileText, path: '/sistema/templates',
    tourDesc: 'Gerencie modelos de mensagem padronizados para comunicacao.',
    tabTour: { title: 'Templates', desc: 'Gerencie templates de comunicacao. Modelos padronizados para mensagens e email.', tips: ['Modelos de mensagem', 'Templates de email', 'Padronizacao'], version: 2 },
  },
  pesquisas: {
    key: 'pesquisas', label: 'Pesquisas Focadas', icon: Search, path: '/sistema/pesquisas',
    tourDesc: 'Crie pesquisas direcionadas para coletar feedback e dados estrategicos.',
    tabTour: { title: 'Pesquisas Focadas', desc: 'Crie pesquisas direcionadas para seu publico. Colete feedback e dados estrategicos.', tips: ['Pesquisas de satisfacao', 'Coleta de feedback', 'Dados estrategicos'], version: 2 },
  },
  comunidades: {
    key: 'comunidades', label: 'Comunidades', icon: Send, path: '/sistema/comunidades',
    tourDesc: 'Publique ofertas em plataformas como Promobit e Pelando.',
    tabTour: { title: 'Comunidades', desc: 'Publique ofertas em comunidades. Gerencie engajamento e moderacao.', tips: ['Publicar em plataformas', 'Engajamento', 'Historico'], version: 2 },
  },
  aplicativos: {
    key: 'aplicativos', label: 'Aplicativos', icon: Smartphone, path: '/sistema/aplicativos',
    tourDesc: 'Versoes do aplicativo, downloads e notas de versao.',
    tabTour: { title: 'Aplicativos', desc: 'Informacoes sobre o app. Versao, downloads e plataformas disponiveis.', tips: ['Versao atual', 'Downloads', 'Plataformas'], version: 2 },
  },
  usuarios: {
    key: 'usuarios', label: 'Usuários', icon: Users, path: '/sistema/usuarios',
    tourDesc: 'Administracao de usuarios, permissoes e controle de acessos.',
    tabTour: { title: 'Usuarios', desc: 'Administracao de usuarios do sistema. Permissoes, aprovacoes e gestao de acessos.', tips: ['Gestao de permissoes', 'Aprovacoes', 'Controle de acesso'], version: 2 },
  },
  alertas: {
    key: 'alertas', label: 'Alertas', icon: Bell, path: '/sistema/alertas',
    tourDesc: 'Notificacoes do sistema, eventos importantes e avisos operacionais.',
    tabTour: { title: 'Alertas', desc: 'Notificacoes criticas e avisos operacionais do sistema.', tips: ['Alertas criticos', 'Notificacoes', 'Avisos operacionais'], version: 2 },
  },
  'admin-empresas': {
    key: 'admin-empresas', label: 'Empresas & Planos', icon: Building2, path: '/sistema/admin/empresas',
    tourDesc: 'Gerencie contas empresariais, planos, assinaturas e trials.',
    tabTour: { title: 'Empresas & Planos', desc: 'Gerencie contas empresariais. Planos, assinaturas, trials e configuracoes.', tips: ['Gestao de planos', 'Assinaturas', 'Trials'], version: 2 },
  },
  'admin-indicacoes': {
    key: 'admin-indicacoes', label: 'Indicações', icon: Users, path: '/sistema/admin/indicacoes',
    tourDesc: 'Gerencie profissionais recomendados, aprovacoes e destaques.',
    tabTour: { title: 'Indicacoes', desc: 'Gerencie profissionais recomendados. Aprovacoes, avaliacoes e destaque.', tips: ['Lista de indicacoes', 'Aprovacoes', 'Destaques'], version: 2 },
  },
  'admin-analytics': {
    key: 'admin-analytics', label: 'Analytics', icon: BarChart3, path: '/sistema/admin/analytics',
    tourDesc: 'Dados analiticos avancados. Metricas de uso, conversao e comportamento.',
    tabTour: { title: 'Analytics', desc: 'Dados analiticos avancados. Metricas de uso, conversao e comportamento de usuarios.', tips: ['Metricas de uso', 'Conversao', 'Comportamento'], version: 2 },
  },
  'admin-redirects': {
    key: 'admin-redirects', label: 'Redirecionador', icon: ArrowUpRight, path: '/sistema/admin/redirects',
    tourDesc: 'Gerencie redirecionamentos de links, tracking de cliques e afiliados.',
    tabTour: { title: 'Redirecionador', desc: 'Gerencie redirecionamentos de links. Tracking de cliques e campanhas de afiliados.', tips: ['Links de redirecionamento', 'Tracking', 'Afiliados'], version: 2 },
  },
  'admin-master': {
    key: 'admin-master', label: 'Admin Master', icon: Shield, path: '/sistema/admin/master',
    tourDesc: 'Painel administrativo com integracoes, funil e configuracoes avancadas.',
    tabTour: { title: 'Admin Master', desc: 'Painel administrativo principal. Integracoes, funil e configuracoes avancadas.', tips: ['Integracoes', 'Funil', 'Configuracoes avancadas'], version: 2 },
  },
  marketplaces: {
    key: 'marketplaces', label: 'Marketplaces', icon: Globe, path: '/sistema/marketplaces',
    tourDesc: 'Conecte lojas e plataformas. Importe ofertas do Mercado Livre, Amazon e mais.',
    tabTour: { title: 'Marketplaces', desc: 'Hub de integracoes com marketplaces. Conecte lojas para importar ofertas automaticamente.', tips: ['Conectar lojas', 'Importar ofertas', 'Status de integracoes'], version: 2 },
  },

  // ---- EMPRESA ----
  'emp-dashboard': {
    key: 'emp-dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/sistema/empresa',
    tourDesc: 'Visao geral da empresa com KPIs, pedidos recentes e performance.',
    tabTour: { title: 'Dashboard da Empresa', desc: 'Visao geral da sua empresa. Metricas, pedidos recentes e indicadores de performance.', tips: ['Metricas da empresa', 'Pedidos recentes', 'Performance'], version: 2 },
  },
  'emp-gestao': {
    key: 'emp-gestao', label: 'Gestão', icon: DollarSign, path: '/sistema/empresa/gestao',
    tourDesc: 'Gestao operacional. Equipe, escalas, configuracoes e controle diario.',
    tabTour: { title: 'Gestao Empresarial', desc: 'Gerencie operacoes do dia a dia. Equipe, escalas e controle operacional.', tips: ['Equipe e escalas', 'Configuracoes', 'Controle operacional'], version: 2 },
  },
  'emp-financeiro': {
    key: 'emp-financeiro', label: 'Financeiro', icon: CreditCard, path: '/sistema/empresa/financeiro',
    tourDesc: 'Receitas, despesas e fluxo de caixa em tempo real.',
    tabTour: { title: 'Financeiro', desc: 'Acompanhe receitas, despesas e fluxo de caixa em tempo real.', tips: ['Receitas e despesas', 'Fluxo de caixa', 'Relatorios'], version: 2 },
  },
  'emp-performance': {
    key: 'emp-performance', label: 'Performance', icon: BarChart3, path: '/sistema/empresa/performance',
    tourDesc: 'Graficos e metricas de performance da empresa.',
    tabTour: { title: 'Performance', desc: 'Analise graficos e metricas avancadas de performance.', tips: ['Graficos de vendas', 'Metricas', 'Comparativos'], version: 2 },
  },
  'emp-comparativo': {
    key: 'emp-comparativo', label: 'Comparativo', icon: BarChart3, path: '/sistema/empresa/comparativo',
    tourDesc: 'Compare metricas entre unidades e periodos.',
    tabTour: { title: 'Comparativo', desc: 'Compare performance entre unidades e periodos.', tips: ['Comparacao entre unidades', 'Evolucao temporal', 'Rankings'], version: 2 },
  },
  'emp-colaboradores': {
    key: 'emp-colaboradores', label: 'Colaboradores', icon: Users, path: '/sistema/empresa/colaboradores',
    tourDesc: 'Cadastre e gerencie membros da equipe, funcoes e permissoes.',
    tabTour: { title: 'Colaboradores', desc: 'Gerencie sua equipe. Adicione colaboradores e defina permissoes.', tips: ['Adicionar colaboradores', 'Permissoes', 'Atividades'], version: 2 },
  },
  'emp-unidades': {
    key: 'emp-unidades', label: 'Unidades / Filiais', icon: Building2, path: '/sistema/empresa/unidades',
    tourDesc: 'Gerencie unidades e filiais da empresa.',
    tabTour: { title: 'Unidades', desc: 'Gerencie suas unidades e filiais. Enderecos, equipes e configuracoes.', tips: ['Cadastro de unidades', 'Equipes por unidade', 'Configuracoes'], version: 2 },
  },
  'emp-ranking': {
    key: 'emp-ranking', label: 'Ranking de Unidades', icon: Trophy, path: '/sistema/empresa/ranking',
    tourDesc: 'Ranking de performance entre unidades da empresa.',
    tabTour: { title: 'Ranking', desc: 'Veja o ranking de performance entre unidades.', tips: ['Ranking geral', 'Metricas por unidade', 'Destaques'], version: 2 },
  },
  'emp-openfinance': {
    key: 'emp-openfinance', label: 'Open Finance', icon: CreditCard, path: '/sistema/empresa/open-finance',
    tourDesc: 'Conexoes bancarias, extratos e gestao financeira.',
    tabTour: { title: 'Open Finance', desc: 'Conexoes bancarias e gestao financeira avancada.', tips: ['Conexoes bancarias', 'Extratos', 'Gestao financeira'], version: 2 },
  },
  ponto: {
    key: 'ponto', label: 'Ponto Digital', icon: Clock, path: '/sistema/ponto',
    tourDesc: 'Registre ponto com geolocalizacao. Acompanhe marcacoes em tempo real.',
    tabTour: { title: 'Ponto Digital', desc: 'Controle de ponto com geolocalizacao e alertas automaticos.', tips: ['Marcacoes em tempo real', 'Geofencing', 'Relatorios'], version: 2 },
  },
  'emp-escalas': {
    key: 'emp-escalas', label: 'Escalas e Jornadas', icon: CalendarDays, path: '/sistema/empresa/escalas',
    tourDesc: 'Configure turnos, horarios e jornadas padrao para a equipe.',
    tabTour: { title: 'Escalas e Jornadas', desc: 'Configure turnos, horarios de trabalho e jornadas.', tips: ['Turnos', 'Horarios', 'Jornadas padrao'], version: 2 },
  },
  'emp-alertas-historico': {
    key: 'emp-alertas-historico', label: 'Historico de Alertas', icon: History, path: '/sistema/empresa/alertas-historico',
    tourDesc: 'Historico completo de alertas e notificacoes da empresa.',
    noTour: true,
  },
  copilot: {
    key: 'copilot', label: 'Copilot', icon: Bot, path: '/sistema/copilot',
    tourDesc: 'Assistente inteligente para ajudar nas operacoes do dia a dia.',
    tabTour: { title: 'Copilot IA', desc: 'Assistente inteligente. Tire duvidas e otimize operacoes.', tips: ['Perguntas inteligentes', 'Sugestoes automaticas', 'Ajuda contextual'], version: 2 },
  },
  'emp-permissoes': {
    key: 'emp-permissoes', label: 'Permissões e Acessos', icon: ShieldCheck, path: '/sistema/empresa/permissoes',
    tourDesc: 'Controle de acesso e permissoes para colaboradores.',
    tabTour: { title: 'Permissoes', desc: 'Controle de acesso e permissoes da empresa.', tips: ['Niveis de acesso', 'Permissoes por modulo', 'Auditoria'], version: 2 },
  },
  'emp-config': {
    key: 'emp-config', label: 'Configurações', icon: Building2, path: '/sistema/empresa/configuracoes',
    tourDesc: 'Personalize dados, logo e configuracoes da empresa.',
    tabTour: { title: 'Configuracoes', desc: 'Personalize sua empresa. Logo, dados e configuracoes avancadas.', tips: ['Dados da empresa', 'Personalizacao', 'Contato'], version: 2 },
  },
  'emp-whatsapp': {
    key: 'emp-whatsapp', label: 'WhatsApp Business', icon: MessageSquare, path: '/sistema/empresa/whatsapp',
    tourDesc: 'Configure integracao com WhatsApp Business.',
    tabTour: { title: 'WhatsApp Business', desc: 'Configure integracao com WhatsApp Business.', tips: ['Conexao', 'Mensagens automaticas', 'Templates'], version: 2 },
  },
  'emp-assinatura': {
    key: 'emp-assinatura', label: 'Assinatura / Plano', icon: CreditCard, path: '/sistema/empresa/assinatura',
    tourDesc: 'Gerencie seu plano, veja detalhes e faca upgrade.',
    tabTour: { title: 'Assinatura', desc: 'Gerencie seu plano e faca upgrade para liberar mais recursos.', tips: ['Detalhes do plano', 'Fazer upgrade', 'Historico'], version: 2 },
  },
  'emp-solicitacoes': {
    key: 'emp-solicitacoes', label: 'Solicitações / Ajustes', icon: ClipboardList, path: '/sistema/empresa/solicitacoes',
    tourDesc: 'Solicite ajustes e correcoes. Acompanhe o status.',
    tabTour: { title: 'Solicitacoes', desc: 'Solicite ajustes e correcoes. Acompanhe cada pedido.', tips: ['Solicitar ajuste', 'Status de pedidos', 'Historico'], version: 2 },
  },
  'emp-indicacoes': {
    key: 'emp-indicacoes', label: 'Indicações', icon: Star, path: '/sistema/empresa/indicacoes',
    tourDesc: 'Profissionais recomendados para sua empresa.',
    tabTour: { title: 'Indicacoes', desc: 'Profissionais recomendados para sua empresa.', tips: ['Recomendacoes', 'Avaliacoes', 'Contato'], version: 2 },
  },
  suporte: {
    key: 'suporte', label: 'Suporte', icon: HelpCircle, path: '/sistema/suporte',
    tourDesc: 'Ajuda e documentacao. Tire duvidas e abra chamados.',
    tabTour: { title: 'Suporte', desc: 'Ajuda, documentacao e contato direto com suporte.', tips: ['Central de ajuda', 'Abrir chamado', 'FAQ'], version: 2 },
  },

  // ---- COLABORADOR ----
  'col-dashboard': {
    key: 'col-dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/sistema/colaborador',
    tourDesc: 'Seu painel com indicadores pessoais, ultima marcacao e status do dia.',
    tabTour: { title: 'Painel do Colaborador', desc: 'Visao geral das suas atividades. Tarefas, solicitacoes e informacoes do dia.', tips: ['Suas tarefas', 'Solicitacoes pendentes', 'Informacoes do dia'], version: 2 },
  },
  'col-meudia': {
    key: 'col-meudia', label: 'Meu Dia', icon: SunMedium, path: '/sistema/colaborador/meu-dia',
    tourDesc: 'Acompanhe seu turno em tempo real. Timeline da jornada e tempo trabalhado.',
    tabTour: { title: 'Meu Dia', desc: 'Acompanhe seu turno com timeline, marcacoes e tempo trabalhado.', tips: ['Timeline da jornada', 'Marcacoes', 'Tempo trabalhado'], version: 2 },
  },
  'col-historico': {
    key: 'col-historico', label: 'Meu Histórico', icon: History, path: '/sistema/colaborador/historico',
    tourDesc: 'Consulte marcacoes por dia, semana ou mes. Horas trabalhadas e pendencias.',
    tabTour: { title: 'Meu Historico', desc: 'Consulte todas as suas marcacoes e horas trabalhadas.', tips: ['Marcacoes por periodo', 'Horas trabalhadas', 'Pendencias'], version: 2 },
  },
  'col-solicitacoes': {
    key: 'col-solicitacoes', label: 'Solicitações', icon: ClipboardList, path: '/sistema/colaborador/solicitacoes',
    tourDesc: 'Solicite ajustes de ponto e justificativas. Acompanhe o status.',
    tabTour: { title: 'Solicitacoes', desc: 'Solicite ajustes de ponto e justificativas.', tips: ['Ajustes de ponto', 'Justificativas', 'Status'], version: 2 },
  },
  conta: {
    key: 'conta', label: 'Meu Perfil', icon: UserCircle, path: '/sistema/conta',
    tourDesc: 'Acesse seu perfil, altere dados pessoais e acompanhe seus pontos.',
    noTour: true,
  },
};

// ==================== SECTION CONFIGS ====================

const ADMIN_SECTIONS = [
  { label: 'Visão geral', keys: ['dashboard'] },
  { label: 'Operação', keys: ['campanhas', 'promocoes', 'gestao', 'admin-crm', 'pedidos', 'descobertas', 'cowork-ofertas', 'ml-afiliados', 'amazon-manual'] },
  { label: 'Canais & integrações', keys: ['conexoes', 'marketplaces'] },
  { label: 'Automações', keys: ['automacoes'] },
  { label: 'Analytics', keys: ['performance', 'comissoes'] },
  { label: 'Conteúdo', keys: ['templates', 'pesquisas', 'comunidades'] },
  { label: 'Administração', keys: ['usuarios', 'alertas', 'admin-empresas', 'admin-indicacoes', 'admin-analytics', 'admin-redirects', 'admin-master'] },
  { label: 'Sistema', keys: ['aplicativos'] },
];

const EMPRESA_SECTIONS = [
  { label: 'Empresa', keys: ['emp-dashboard', 'emp-gestao', 'emp-financeiro', 'emp-performance', 'emp-comparativo', 'emp-colaboradores', 'emp-unidades', 'emp-ranking', 'emp-openfinance'] },
  { label: 'Operação', keys: ['ponto', 'emp-escalas', 'alertas', 'emp-alertas-historico', 'copilot'] },
  { label: 'Sistema da Empresa', keys: ['emp-permissoes', 'emp-config', 'emp-whatsapp', 'emp-assinatura', 'emp-solicitacoes'] },
  { label: 'Utilidades', keys: ['emp-indicacoes', 'aplicativos', 'suporte'] },
];

const COLABORADOR_SECTIONS = [
  { label: 'Meu Painel', keys: ['col-dashboard', 'col-meudia', 'ponto', 'col-historico'] },
  { label: 'Utilidades', keys: ['alertas', 'copilot', 'suporte'] },
  { label: 'Conta', keys: ['col-solicitacoes', 'aplicativos', 'conta'] },
];

// ==================== PUBLIC API ====================

export function getItem(key) {
  return ALL_ITEMS[key] || null;
}

export function getNavSections(profile) {
  const config = profile === 'empresa' ? EMPRESA_SECTIONS : profile === 'colaborador' ? COLABORADOR_SECTIONS : ADMIN_SECTIONS;
  return config.map(sec => ({
    label: sec.label,
    items: sec.keys.map(k => ALL_ITEMS[k]).filter(Boolean),
  }));
}

export function getMainTourItems(profile) {
  const sections = getNavSections(profile);
  const items = [];
  for (const sec of sections) {
    for (const item of sec.items) {
      if (item.noTour) continue;
      if (!item.tourDesc) {
        if (process.env.NODE_ENV === 'development') {
          console.warn(`[NavRegistry] Item "${item.key}" sem tourDesc. Adicione conteudo de tour.`);
        }
        continue;
      }
      items.push(item);
    }
  }
  return items;
}

export function getTabTourContent(tabKey) {
  const item = ALL_ITEMS[tabKey];
  if (!item || !item.tabTour) return null;
  return item.tabTour;
}

// Path to tab key mapping — auto-generated from ALL_ITEMS + aliases
const PATH_TO_KEY = {};
for (const [key, item] of Object.entries(ALL_ITEMS)) {
  if (item.path) PATH_TO_KEY[item.path] = key;
}
// Aliases for paths that share tabKey with parent
const PATH_ALIASES = {
  '/sistema/empresa/comparativo': 'emp-comparativo',
  '/sistema/empresa/unidades': 'emp-unidades',
  '/sistema/empresa/ranking': 'emp-ranking',
  '/sistema/empresa/escalas': 'emp-escalas',
  '/sistema/empresa/whatsapp': 'emp-whatsapp',
  '/sistema/empresa/permissoes': 'emp-permissoes',
  '/sistema/empresa/open-finance': 'emp-openfinance',
  '/sistema/empresa/alertas-historico': 'emp-alertas-historico',
  '/sistema/colaborador/solicitacoes': 'col-solicitacoes',
};
Object.assign(PATH_TO_KEY, PATH_ALIASES);

export function getTabKeyForPath(path) {
  return PATH_TO_KEY[path] || '';
}

// Safeguard: check for missing tour content
export function validateRegistry() {
  const issues = [];
  for (const [key, item] of Object.entries(ALL_ITEMS)) {
    if (item.noTour) continue;
    if (!item.tourDesc) issues.push(`${key}: falta tourDesc`);
    if (!item.tabTour) issues.push(`${key}: falta tabTour`);
  }
  return issues;
}
